import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, OnInit, OnChanges } from '@angular/core';
import { UserGroup } from '../../user/user-group';
import {ChatbotAvailableProfile} from '../state/chatbot-available-profile';
import {ChatbotAvailableTeam} from '../state/chatbot-available-team';
import {TranslatorService} from '../../translation/translator.service';

@Component({
  selector: 'app-mention-overlay',
  templateUrl: './mention-overlay.component.html',
  styleUrls: ['./mention-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MentionOverlayComponent implements OnInit, OnChanges {
  @Input() users: UserGroup[] = [];
  @Input() defaultUsers: ChatbotAvailableProfile[] = [];
  @Input() defaultTeams: ChatbotAvailableTeam[] = [];
  @Input() activeIndex: number = 0;
  @Input() position = { top: 0, left: 0 };
  @Input() visible: boolean = true;

  @Output() userSelected = new EventEmitter<UserGroup>();
  @Output() defaultTeamSelected = new EventEmitter<ChatbotAvailableTeam>();
  @Output() overlayClose = new EventEmitter<void>();
  @Output() activeIndexChanged = new EventEmitter<number>();

  constructor(private translatorService: TranslatorService) {
  }

  ngOnInit(): void {
    this.buildCombinedDefault();
  }

  ngOnChanges(): void {
    // Handle changes to inputs
  }

  onHover(i: number): void {
    this.activeIndex = i;
    this.activeIndexChanged.emit(i);
  }

  private buildCombinedDefault(): void {

  }

  selectDefaultUser(user: ChatbotAvailableProfile): void {
    this.selectUser({
      keycloakId: user.keycloakId,
      firstName: user.firstName,
      lastName: user.lastName,
      groupName: '-'
    });
  }

  selectDefaultTeam(team: ChatbotAvailableTeam): void {
    this.defaultTeamSelected.emit(team);
  }

  selectUser(user: UserGroup): void {
    this.userSelected.emit(user);
  }

  trackByFn(index: number, user: UserGroup): string {
    return user.keycloakId;
  }

  __(key: string): string {
    return this.translatorService.translate('chat.' + key);
  }
}
